import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Row, Col } from 'antd';
import styles from './LayoutBlockTextImage.module.scss';
import { GlobalImage, ImageType, ImageEntity, ImagePosition, GlobalCta } from 'src/modules/global';
import { CtaProps } from 'src/modules/global/components/cta/Cta';
import { RowProps } from 'antd/lib/row';

const rowProps: RowProps = { gutter: [40, 20] };

export interface LayoutBlockTextImageProps {
  title: string;
  title_En?: string;
  title_De?: string;
  subline?: string | React.ReactNode;
  label?: string;
  image_position?: ImagePosition;
  image: ImageEntity;
  // stretch?: boolean;
  // even?: boolean;
  link?: string;
  ratio?: number;
  button?: CtaProps;
}

const LayoutBlockTextImage: React.FunctionComponent<LayoutBlockTextImageProps> = (
  props: LayoutBlockTextImageProps
) => {
  const { locale } = useRouter();
  const [hack, setHack] = useState('');

  useEffect(() => {
    setHack('hack');
  }, []);

  const newProps = { ...props };
  if (!newProps.title && newProps.title_En) {
    newProps.title = locale === 'de' ? newProps.title_De : newProps.title_En;
  }
  const {
    image,
    image_position = ImagePosition.Right,
    subline,
    title,
    label,
    // stretch = false,
    // even = true,
    link = '',
    ratio,
    button,
  } = newProps;

  const imageOutput = (
    <GlobalImage
      key={4}
      type={ImageType.Raw}
      {...image}
      link={link}
      ratio={ratio}
      captionSize="small"
    />
  );

  const textOutput = (
    <div className={styles.innerContainer}>
      {label && <div className={styles.label}>{label}</div>}
      {title && <h3 className={styles.title}>{title}</h3>}
      {React.isValidElement(subline)
        ? subline
        : typeof subline === 'string' && (
            <div className={styles.subline} dangerouslySetInnerHTML={{ __html: subline }} />
          )}
      {!!button && <GlobalCta {...button} />}
    </div>
  );

  let output;

  //Check where the image is placed: Left or Right
  switch (image_position as string) {
    case ImagePosition.Left:
      output = [
        <Col
          key={'image-1'}
          xs={{ span: 24 }}
          md={{ span: 10, offset: 2 }}
          className={styles.textContainer}>
          {imageOutput}
        </Col>,
        // If it's even, both columns will have the same span, otherwise 8 for text and 16 for the image (3/4 format)
        <Col
          xs={{ span: 24 }}
          md={{ span: 8, offset: 2 }}
          key={'text-2'}
          className={styles.textContainer}>
          {textOutput}
        </Col>,
      ];
      break;
    case ImagePosition.Right:
    default:
      output = [
        <Col
          xs={{ span: 24, order: 2, offset: 0 }}
          key={'text-1'}
          md={{ span: 8, offset: 2, order: 1 }}
          className={styles.textContainer}>
          {textOutput}
        </Col>,

        <Col
          key={'image-2'}
          xs={{ span: 24, order: 1 }}
          md={{ span: 10, offset: 2, order: 2 }}
          className={styles.textContainer}>
          {imageOutput}
        </Col>,
      ];
      break;
  }
  return (
    <div key={`text-image-${hack}`} className={styles.container}>
      <Row {...rowProps}>{output}</Row>
    </div>
  );
};

export default LayoutBlockTextImage;
